import { _t } from '../base.js'

export function initThankYouPage() {
    if ($('.id--15').length) {
        thankYouPageTextChanges()
        orderNumber()
        cartProducts()
        localStorage.removeItem('productsExpirationData')
    }
}

function thankYouPageTextChanges() {
    $('.order-summary-heading').text(_t('cart.thankYouPage.heading'))
}

function orderNumber() {
    $('.content-inner').html(function (index, text) {
        return text
            .replace(_t('cart.thankYouPage.thankYouOrderNumber'), '')
            .replace(_t('cart.thankYouPage.orderNumber'), '')
            .replace('Rekapitulaci Vám zašleme i e-mailem.', '')
    })

    const content = document.querySelector('.content-inner')
    content.childNodes[4].textContent = ''

    // Get order number and add new row to table
    const orderNumber = getOrderNumber()
    const newRow = `
        <tr data-testid="recapCartItem">
            <th>
                <span class="row-header-label">${_t('cart.thankYouPage.orderNumber')}</span>
            </th>
            <td data-testid="recapOrderNumber">
                ${orderNumber}
            </td>
        </tr>
    `
    $('.recapitulation-table tbody').prepend(newRow)
}

function getOrderNumber() {
    const orderNumber = $('.content-inner > span').text()
    return orderNumber
}

function cartProducts() {
    $('tr[data-testid="recapItem"]').each(function () {
        const pTotal = $(this).find('.p-total')
        pTotal.append($(`<span class="with-dph">${_t('cart.global.withDph')}</span>`))
    })
}
